import React, { Component, Fragment, useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col, Card, CardBody } from "reactstrap"

import Breadcrumbs from "../../../components/Common/Breadcrumb2"
import SoftskillsUsersListTable from "components/SoftSkills/Users/SoftskillsUsersListTable"

const SoftskillsUsersList = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Usuarios | Soft Skills</title>
        </MetaTags>
        <Container fluid>
          <Row>
            <Col sm={4}>
              <h4>Gestión de usuarios</h4>
            </Col>
            <Col sm={8}>
              <Breadcrumbs
                breadcrumbItems={[
                  { key: "dashboard", title: "Inicio", link: "/soft-skills" },
                  { key: "users", title: "Usuarios" },
                ]}
              />
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <SoftskillsUsersListTable />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SoftskillsUsersList
